/**
 * @summary Wrapper for an item in the browser's local storage.
 * 
 * Some of this class's methods assume that the value in the K-V local storage pair is an array-like object.
 */
export default class BrowserLocalStorage {
	constructor(key) {
		this.key = key;
	}

	/**
	 * @summary Does this instance's key exist in local storage?
	 * @returns {boolean}
	 */
	keyExists() {
		return !!localStorage.getItem(this.key);
	}

	/**
	 * @summary Get the value of the key in local storage if it exists. Return null otherwise.
	 * @returns {string | null} Item in local storage.
	 */
	getValue() {
		return this.keyExists() ? localStorage.getItem(this.key) : null;
	}

	/**
	 * @summary Does the value exist in the value in local storage?
	 * @param {any} value 
	 * @returns {boolean}
	 */
	valueExists(value) {
		const results = JSON.parse(this.getValue());
		return !!results.includes(value);
	}

	/**
	 * @summary Append a value to an existing value in local storage.
	 * @param {any} value Value to append.
	 */
	appendToExisitingValues(value) {
		const results = JSON.parse(this.getValue());
		results.push(value);
		localStorage.setItem(this.key, JSON.stringify(results));
	}

	/**
	 * @summary Save a value as an element of an array to this instance's key in local storage.
	 * @param {any} value 
	 */
	setValueAsArray(value) {
		localStorage.setItem(this.key, JSON.stringify([value]));
	}
}
